import $ from "jquery";
import "slick-carousel";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";

$(function () {
	$("#HomePageSlider").slick({
		adaptiveHeight: false,
		autoplay: true,
		arrows: true,
		dots: true,
		infinite: true,
		rows: 0,
		autoplayspeed: 8000,
		slidesToShow: 1,
		fade: true,
		cssEase: "linear",
		lazyLoad: "ondemand",
		prevArrow:
			'<i class="HomePageSlider-control--left far fa-chevron-left"></i>',
		nextArrow:
			'<i class="HomePageSlider-control--right far fa-chevron-right"></i>',
	});
});
